<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">{{ `${pack.name}` }} - {{ $t("COMMON.LOGS") }}</h3>
    <log-list-table :filterSubject="pack" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "package-view-logs",

  components: { LogListTable },

  props: ["pack"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    pack(pack) {},
  },
};
</script>
